import { createContext } from "react";

const FeedbackContext = createContext(
  { 
    feedback: {
        bdOpen: false,
        snackType: "",
    },  
    setFeedback: () => { }, 
    enqueueSnackbar: false,
    closeSnackbar: false,
  }
);

export default FeedbackContext;

